import useForm from "../../../hooks/useForm";
import AuthHeader from "../sections/Auth.header";
import AuthRight from "../sections/Auth.Right";
import AuthFooter from "../sections/Auth.Footer";
import AuthIllustration from "../components/AuthIllustration";
import AuthLayout from "../../../layouts/Auth.layout";
import { useLoginApi } from "../apis";
import { useBreakpointValue } from "@chakra-ui/react";
import { useEffect } from "react";
import { useAlert } from "../../../hooks/useAlert";
import { useValidateSessionStorage } from "../helper";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../store";

const SignupPage = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  useValidateSessionStorage("selectedValues", "/welcome");

  const { signupWithEmailAndPassword } = useLoginApi();
  const { message, loading } = useAppSelector((s) => s.auth);

  const { showAlert, render: AlertRender, hideAlert } = useAlert();
  const navigate = useNavigate();
  const { render: formRender, setLoading } = useForm<
    "email" | "name" | "password"
  >({
    initialValues: {
      email: {
        type: "email",
        value: "",
        label: "Email",
        placeholder: "Email",
      },
      name: {
        type: "text",
        value: "",
        placeholder: "Name",
        label: "Name",
        validation: {
          required: { value: true, message: "Name is required" },
        },
      },
      password: {
        type: "password",
        value: "",
        label: "Password",
        placeholder: "Password",
        showEye: true,
      },
    },
    inputSize: "lg",
    showLabel: isMobile!,
    submitLabel: "Sign Up",
    onSubmit: (data) => {
      signupWithEmailAndPassword(data as any);
    },
  });

  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  useEffect(() => {
    if (message) showAlert({ status: message.status, message: message.value });
    else hideAlert();
  }, [message]);

  return (
    <AuthLayout
      Header={AuthHeader({
        onBack: () => navigate("/welcome"),
      })}
      Left={isMobile ? <></> : AuthIllustration()}
      Right={AuthRight({
        form: formRender(),
        error: AlertRender,
      })}
      Footer={AuthFooter({ for: "signup" })}
    />
  );
};

export default SignupPage;
